/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

type ColophonContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const ColophonContext = createContext<ColophonContextValue | null>(null);

export function ColophonProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const value = useMemo<ColophonContextValue>(() => ({ isOpen, open, close }), [isOpen, open, close]);
  return <ColophonContext.Provider value={value}>{children}</ColophonContext.Provider>;
}

export function useColophon(): ColophonContextValue {
  const ctx = useContext(ColophonContext);
  if (!ctx) throw new Error('useColophon must be used inside <ColophonProvider>.');
  return ctx;
}
